import  secureLocalStorage  from  "react-secure-storage";

export const getToken = () => {
    const token = secureLocalStorage.getItem('session')?.token;
    return token;
}

export const getUserId = ()=>{
    const userId = secureLocalStorage.getItem('session')?.userId;
    return userId;
}

export const setTokeSync = (token)=>{
    secureLocalStorage.setItem('access_token', token);
}

export const getTokeSync = (token)=>{
    return secureLocalStorage.getItem('access_token');
}

export const removeTokeSync = (token)=>{
    secureLocalStorage.removeItem('access_token');
}

export const setCollapsed = (collapsed)=>{
    secureLocalStorage.setItem('collapsed', collapsed);
}

export const getCollapsed = ()=>{
    return secureLocalStorage.getItem('collapsed');
}